import type { IconAsset } from '../Icon.types';

const code = (
  <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
    <g>
      <polygon points='0 0 24 0 24 24 0 24'></polygon>
      <path
        d='M11.9870959,2.00002076 C6.46593628,2.00716576 1.99525969,6.48746582 2.00000377,12.008628 C2.00475541,17.5297901 6.48313093,22.0023945 12.0042946,22.0000208 C17.5254583,21.9976512 22.0000038,17.5212011 22.0000038,12.0000369 C22.0019998,9.34502197 20.9473035,6.79836165 19.0687139,4.92219287 C17.1901242,3.0460241 14.642106,1.99461261 11.9870959,2.00002076 L11.9870959,2.00002076 Z M18.9150495,7.99896355 L15.9666638,7.99896355 C15.653802,6.76072234 15.1904981,5.56544885 14.5870946,4.43982546 C16.4108008,5.06765124 17.9475159,6.33107081 18.9161248,7.99896355 L18.9150495,7.99896355 Z M11.9999991,4.04305146 C12.8398172,5.25469949 13.4842203,6.59067481 13.9096756,8.00218935 L10.088172,8.00218935 C10.5142934,6.59054423 11.1594256,5.25456191 11.9999991,4.04305146 L11.9999991,4.04305146 Z M4.25806729,14.0000359 C3.9115043,12.6895876 3.9115043,11.3115615 4.25806729,10.0011131 L7.63871084,10.0011131 C7.55164532,10.6643324 7.50496432,11.3322297 7.49892596,12.0011131 C7.50496432,12.6699946 7.55164532,13.337892 7.63871084,14.0011131 L4.25806729,14.0000359 Z M5.07742174,16.000035 L8.02795796,16.000035 C8.34081979,17.2382762 8.80412368,18.4335497 9.4075272,19.5591731 C7.5819026,18.9347825 6.04410649,17.6704742 5.07849701,16.000035 L5.07742174,16.000035 Z M8.02795796,7.99896355 L5.07957227,7.99896355 C6.04518176,6.32852434 7.58297786,5.06421607 9.40860246,4.43982546 C8.80519895,5.56544885 8.34189505,6.76072234 8.02903323,7.99896355 L8.02795796,7.99896355 Z M11.9999991,19.9570224 C11.1601809,18.7453743 10.5157778,17.409399 10.0903226,15.9978845 L13.9096756,15.9978845 C13.4842203,17.409399 12.8398172,18.7453743 11.9999991,19.9570224 L11.9999991,19.9570224 Z M14.3397829,13.9989626 L9.65806471,13.9989626 C9.55919884,13.3367182 9.50566934,12.6684976 9.49784973,11.9989626 C9.50526779,11.3294073 9.55879949,10.6611592 9.65806471,9.99896259 L14.3365571,9.99896259 C14.4358223,10.6611592 14.489354,11.3294073 14.4967721,11.9989626 C14.4888547,12.6677793 14.4353255,13.3352781 14.3365571,13.9968101 L14.3397829,13.9989626 Z M14.5892452,19.5570225 C15.1926487,18.4313992 15.6559526,17.2361257 15.9688144,15.9978845 L18.9182753,15.9978845 C17.9489409,17.6657714 16.4114273,18.9288379 14.5870946,19.5559473 L14.5892452,19.5570225 Z M16.3591368,13.9989626 C16.4462023,13.3357414 16.4928833,12.6678441 16.4989217,11.9989626 C16.4928833,11.3300792 16.4462023,10.6621818 16.3591368,9.99896259 L19.7387051,9.99896259 C20.085268,11.3094109 20.085268,12.6874371 19.7387051,13.9978854 L16.3591368,13.9989626 Z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </g>
  </g>
);

export const language: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
